import React from 'react';
import { useParams } from 'react-router-dom';

import { GameDocumentContext } from '../../../../../contexts/game-document';
import { GetResourceValue } from '../../../../../utils/game-document/resources';
import { GetTaskContentByTaskId } from '../../../../../utils/game-engine/player';
import { useGetPlayerStateByTeamCode } from '../../../../../hooks/use-get-player-state';

export const TaskList: React.FC<{
  selectedTask: string;
  onSelectTask: (taskId: string) => void;
}> = ({ selectedTask, onSelectTask }) => {
  const { gameCode } = useParams();
  const [gameDocument] = React.useContext(GameDocumentContext);

  const { playerStates } = useGetPlayerStateByTeamCode(gameCode);

  const taskList = React.useMemo(() => {
    if (!gameDocument.gameDocument) return [];
    if (!gameDocument.gameDocument.assets.tasks) return [];

    if (!playerStates)
      return gameDocument.gameDocument.assets.tasks.map((task) => ({
        id: task.id,
        name: GetResourceValue(
          gameDocument.gameDocument!,
          task.titleResId ?? '',
          ''
        ),
        count: 0
      }));

    return gameDocument.gameDocument.assets.tasks.map((task) => {
      let count = 0;
      playerStates.forEach((player) => {
        const tasks = player.playerState?.tasks || [];

        tasks.forEach((playerTask) => {
          if (playerTask.id !== task.id || !playerTask.taskContentFormAnswers)
            return;
          playerTask.taskContentFormAnswers.forEach((formAnswer) => {
            const taskContent = GetTaskContentByTaskId(
              gameDocument.gameDocument!,
              playerTask.id ?? ''
            );
            const form = taskContent?.forms?.find(
              (f) => f.id === formAnswer.formId
            );

            if (form && ['image', 'video'].includes(form.type)) count++;
          });
        });
      });

      return {
        id: task.id,
        name: GetResourceValue(
          gameDocument.gameDocument!,
          task.titleResId ?? '',
          ''
        ),
        count
      };
    });
  }, [gameDocument.gameDocument, playerStates]);

  return (
    <div className={'reels-task-selector'}>
      <div
        className={`${selectedTask === 'All Tasks' ? 'active' : ''}`}
        onClick={() => onSelectTask('All Tasks')}>
        All Tasks
      </div>
      {taskList.map((task) => (
        <div
          key={task.id}
          className={`task ${selectedTask === task.id ? 'active' : ''}`}
          onClick={() => onSelectTask(task.id)}>
          <span>{task.name}</span>
          <span
            style={{
              fontWeight: 'normal',
              color: selectedTask === task.id ? 'white' : '#4698CB'
            }}>
            {task.count}
          </span>
        </div>
      ))}
    </div>
  );
};
